module.exports = "/_next/static/images/192866268de983d839fa3645cb1e7e39-roxinho-scene-card-with-phone-md@1x.jpg.webp";